import { defineMessages } from 'react-intl'

export const sponsoredBenefitsSidePanelMessages = defineMessages({
  subtitle: {
    defaultMessage: 'Sponsored benefits',
    description: 'Subtitle for the sponsored benefits side-panel section',
  },
  loadingTitle: {
    defaultMessage: 'Loading benefits…',
    description: 'Sponsored benefits title while benefit details are loading',
  },
  benefitsAvailableTitle: {
    defaultMessage: 'Benefits available',
    description: 'Collapsed sponsored benefits title when benefits are available',
  },
  noSessionsRemainingTitle: {
    defaultMessage: 'No sessions remaining',
    description: 'Collapsed sponsored benefits title when all covered sessions have been used',
  },
  selfPayTitle: {
    defaultMessage: 'Self-pay',
    description: 'Collapsed sponsored benefits title when self-pay is active',
  },
  selfPayEligibleTitle: {
    defaultMessage: 'Self-pay eligible',
    description: 'Collapsed sponsored benefits title when self-pay is available',
  },
  healthPlanTitle: {
    defaultMessage: 'Health plan',
    description: 'Collapsed sponsored benefits title when care is covered by a health plan',
  },
  noCoverageTitle: {
    defaultMessage: 'No coverage',
    description: 'Sponsored benefits title when the client has no coverage',
  },
  eligibilityNotConfirmedTitle: {
    defaultMessage: 'Not confirmed',
    description: 'Sponsored benefits title when client eligibility is not confirmed',
  },
  benefitsResetDate: {
    defaultMessage: 'Benefits reset on {benefitsResetDate}',
    description: 'Date when the sponsored benefit resets',
  },
  selfPayLabel: {
    defaultMessage: 'Self-pay',
    description: 'Label for client self-pay status',
  },
  selfPayTooltip: {
    defaultMessage: 'After covered sessions, {clientFirstName} can pay for care {reflexivePronoun}.',
    description: 'Tooltip explaining what self-pay means for the client',
  },
  selfPayTooltipAccessibilityLabel: {
    defaultMessage: 'More information about self-pay status',
    description: 'Accessibility label for the self-pay status tooltip',
  },
  eligibleValue: {
    defaultMessage: 'Eligible',
    description: 'Value when a client is eligible for self-pay',
  },
  activeValue: {
    defaultMessage: 'Active',
    description: 'Value when client self-pay is active',
  },
  eligibilityNotConfirmedCareNavigationNotice: {
    defaultMessage:
      '{clientFirstName}’s eligibility not confirmed. Ask them to check their legal name and DOB in their profile. For more help, contact the Lyra Care Navigation Team. <bold>Do not schedule more sessions unless clinically necessary.</bold>',
    description: 'Notice shown when client eligibility is not confirmed',
  },
  eligibilityNotConfirmedHelpCenterNotice: {
    defaultMessage:
      '{clientFirstName}’s eligibility not confirmed. Ask them to check their legal name and DOB in their profile. For more help, <link>submit a ticket</link> through the Help Center.',
    description: 'Notice shown to DA Engage providers when client eligibility is not confirmed',
  },
  lyraSelectTitle: {
    defaultMessage: 'Lyra Select Member',
    description: 'Title for a Lyra Select client notice',
  },
  lyraSelectNotice: {
    defaultMessage:
      '{clientFirstName} has a limited number of EAP sessions (6-8) and programs (coaching and individual therapy only) available to them.',
    description: 'Notice explaining the benefit limits for a Lyra Select client',
  },
  learnMoreAboutLyraSelect: {
    defaultMessage: 'Learn more about Lyra Select.',
    description: 'Link label for more information about Lyra Select',
  },
  viewServicesAndBenefits: {
    defaultMessage: 'View services and benefits',
    description: 'Link label for viewing all client services and benefits',
  },
})
